var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessOrange({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 22C6.477 22 2 17.523 2 12C2 6.477 6.477 2 12 2C17.523 2 22 6.477 22 12C22 17.523 17.523 22 12 22ZM10.823 14.14L8.058 11.373L7 12.431L10.119 15.552C10.3065 15.7395 10.5608 15.8448 10.826 15.8448C11.0912 15.8448 11.3455 15.7395 11.533 15.552L17.485 9.602L16.423 8.54L10.823 14.14Z",
    fill: "#FF7E00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessOrange);
export default __webpack_public_path__ + "static/media/successOrange.80badb6f55e585bdc7baf7556effd67b.svg";
export { ForwardRef as ReactComponent };